var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personal-logo"},[_c('div',{attrs:{"id":"head_safty"}},[_c('div',{staticClass:"logo"},[_c('div',{attrs:{"id":"logo_left"}},[_c('span',{staticStyle:{"font-size":"24px","color":"#ffffff","font-weight":"600"}},[_vm._v(_vm._s(_vm.systemName))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03972b7f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/saftySetting/saftySettingHead/logo.vue
// module id = mD3z
// module chunks = 22